import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { Row, Button, Popup, RecordSelect, Select, Popconfirm, Loader } from '@smartplatform/ui';
import store from '../../store';

@observer
export default class DeputyPopup extends React.Component {

	@observable deputy = null;
	@observable position = '';
	@observable positionNum = 0;
	@observable comment = '';
	@observable error = null;
	@observable isLoading = false;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		const { deputyCommittee } = this.props;
		if (deputyCommittee) {
			this.deputy = deputyCommittee.deputy;
			this.position = deputyCommittee.position || '';
			this.positionNum = deputyCommittee.positionNum || 0;
			this.comment = deputyCommittee.comment || '';
		}
		else {
			this.position = 'член комитета';
			this.positionNum = 0;
		}
	};

	onDeputyChange = record => this.deputy = record;
	onPositionChange = e => this.position = e.target.value;
	onPositionNumChange = value => this.positionNum = value;
	onCommentChange = e => this.comment = e.target.value;

	save = async () => {
		if (!this.deputy) {
			this.error = 'Выберите члена комитета';
			return;
		}
		this.isLoading = true;
		const deputyCommittee = this.props.deputyCommittee || new store.model.DeputyCommittee();
		deputyCommittee.deputy = this.deputy;
		deputyCommittee.position = this.position || null;
		deputyCommittee.positionNum = this.positionNum;
		deputyCommittee.comment = this.comment || null;
		deputyCommittee.committeeId = this.props.committee.id;
		await deputyCommittee.save();
		this.isLoading = false;
		this.props.onChange && this.props.onChange();
		this.props.onClose && this.props.onClose();
	};

	delete = async () => {
		await this.props.deputyCommittee.delete();
		this.props.onChange && this.props.onChange();
		this.props.onClose && this.props.onClose();
	};

	fio = deputy => <>{deputy.lastName} {deputy.firstName} {deputy.middleName}</>;

	render() {
		return <Popup onClose={this.props.onClose} width={500} height={280} scrollable={false}>
			<div className="form-field">
				<label>Депутат</label>
				<RecordSelect
					model={store.model.Deputy}
					computed={this.fio}
					value={this.deputy}
					searchFields={[{name: 'lastName', start: true}]}
					onChange={this.onDeputyChange}
				/>
			</div>
			<div className="form-field">
				<label>Должность</label>
				<Select
					items={[
						{ label: 'председатель комитета', value: 2 },
						{ label: 'заместитель председателя', value: 1 },
						{ label: 'член комитета', value: 0 },
					]}
					isRequired={true}
					noSearch={true}
					value={this.positionNum}
					onChange={this.onPositionNumChange}
				/>
			</div>
			<div className="form-field">
				<label>Должность (старое поле, временно)</label>
				<input type="text" disabled value={this.position || ''} onChange={this.onPositionChange} />
			</div>
{/*
			<div className="form-field">
				<label>Комментарий</label>
				<textarea rows={5} value={this.comment || ''} onChange={this.onCommentChange} />
			</div>
*/}
			<div className="form-field">
				<Button className="btn-primary" onClick={this.save}>{this.props.deputyCommittee ? 'Сохранить' : 'Добавить'}</Button>
				{this.props.deputyCommittee && <>&nbsp; <Popconfirm content="Удалить?" onConfirm={this.delete}>
					<FontAwesomeIcon icon={faTrash} className="delete-btn" />
				</Popconfirm></>}
				{this.isLoading && <>&nbsp; <Loader /></>}
			</div>
			{this.error && <div className="error">{this.error}</div>}
		</Popup>;
	}

}
